import React, { useState, ChangeEvent, useEffect } from 'react';
import { FaSave } from 'react-icons/fa';
import Dates from '~/utils/dates';
import CurrencyInput from '~/components/Modules/CurrencyMask';
import './styles.css';

interface EditPriceModalProps {
    price: any;
    onSave: (priceData: any) => void;
    onCancel: () => void;
}

const EditPriceModal: React.FC<EditPriceModalProps> = ({ price, onSave, onCancel }) => {
    
    const [formData, setFormData] = useState({
        unit_id: price.unit_id,
        year: price.year,
        month: price.month,
        price: price.price,
        type: price.type || 'FIXO',
        id: price.id,
    });

    useEffect(() => {
        setFormData({
            unit_id: price.unit_id,
            year: price.year,
            month: price.month,
            price: price.price,
            type: price.type || 'FIXO',
            id: price.id,
        });
    }, price);

    function onChange(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        const { name, value } = event.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    function onChangeFloat(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>, originalValue: any) {
        const { name } = event.target;
        setFormData(prev => ({ ...prev, [name]: originalValue }));
    }

    function getMonths() {
        let ret: any = [];
        for (let i = 0; i <= 11; i++) {
            let item = {
                month: i + 1,
                name: Dates._getNameMonth(i)
            };
            ret.push(item);
        }
        return ret;
    }

    function getYears() {
        let init = Number(Dates.getYear()),
            ret: any = [];
        for (let i = init; i >= (init - 20); i--) {
            ret.push(i);
        }
        return ret;
    }

    function handleSave() {
        if (!formData.price || formData.price <= 0) {
            alert('Por favor, insira um valor válido para o preço.');
            return;
        }
        onSave(formData);
    }

    function handleCancel() {
        onCancel();
    }

    return (
        <div className="price-modal-container">
            <div className="price-modal-header">
                <h3>Editar Preço</h3>
            </div>

            <div className="price-modal-body">
                <div className="form-group">
                    <label htmlFor="year">Ano:</label>
                    <select
                        id="year"
                        name="year"
                        value={formData.year}
                        onChange={onChange}
                        className="form-select"
                        disabled
                    >
                        {getYears().map((year: any) => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="month">Mês:</label>
                    <select
                        id="month"
                        name="month"
                        value={formData.month}
                        onChange={onChange}
                        className="form-select"
                        disabled
                    >
                        <option value="0">Geral</option>
                        <optgroup label="Meses">
                            {getMonths().map((month: any) => (
                                <option key={month.month} value={month.month}>
                                    {month.name}
                                </option>
                            ))}
                        </optgroup>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="type">Tipo:</label>
                    <select
                        id="type"
                        name="type"
                        value={formData.type}
                        onChange={onChange}
                        className="form-select"
                        disabled
                    >
                        <option value="FIXO">Fixo</option>
                        <option value="GUARANTEED_DISCOUNT">Desconto garantido</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="price">Valor:</label>
                    <CurrencyInput
                        id="price"
                        name="price"
                        placeholder="0,00"
                        onChangeValue={onChangeFloat}
                        value={formData.price}
                        hideSymbol
                        className="form-input"
                    />
                </div>
            </div>

            <div className="price-modal-footer">
                <button className="btn-cancel" onClick={handleCancel}>
                    Cancelar
                </button>
                <button className="btn-save" onClick={handleSave}>
                    <FaSave size={16} />
                    Salvar Alterações
                </button>
            </div>
        </div>
    );
};

export default EditPriceModal;
